module.exports = __webpack_public_path__ + "static/img/my-white.50ecad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my-white.png
// module id = QfGX
// module chunks = 1